/// <amd-module name="Analytics/Shared/Utils/URLHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssHistoryService } from "VSS/Platform/History";

export function getDefinitionIdFromUrl(pageContext: IVssPageContext): number {
    const vssHistoryService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
    const state: any = vssHistoryService.getState();
    const value: number = parseInt(state[_definitionIdQueryParameter], 10) || 0;
    return value;
}

export function getContextTypeFromUrl(pageContext: IVssPageContext): string {
    const vssHistoryService = pageContext.getService<IVssHistoryService>("IVssHistoryService");
    const state: any = vssHistoryService.getState();
    const value: string = state[_contextTypeQueryParameter] || "build";
    return value;
}

const _definitionIdQueryParameter = "definitionId";
const _contextTypeQueryParameter = "contextType";
